import Vue from 'vue'
import * as moment from 'moment';
import 'moment/locale/ru';
Vue.prototype.$moment = moment;